import { ConversationCustomer, ConversationPlatform } from "../conversation";

export enum SatisfactionResponseStatusTypes {
  PENDING = "pending",
  SENT = "sent",
  COMPLETED = "completed",
}

export enum CsatSortableField {
  COMPLETION_DATE = "updatedAt",
}

export interface CsatResponse {
  _id: string;
  team: string;
  // v1 rows carry a Mongo conversation ObjectId; v2 rows carry a branded
  // SupportTicketId string instead. Exactly one is present. The branded
  // type lives in effect-api-shared but that creates a dependency cycle
  // with redo/model — callers cast/assert the brand at boundaries.
  conversation?: string;
  supportTicketId?: string;
  rating: number;
  comment: string;
  channel: ConversationPlatform;
  status: SatisfactionResponseStatusTypes;
  updatedAt: Date;
  createdAt: Date;
  sendAt?: Date;
}

export interface AnalyticsCsatResponse extends CsatResponse {
  customer?: ConversationCustomer;
  assignee?: string;
}
